import { useState, useEffect } from 'react';
import { GEO_LOCATION_WEB_KEY } from '../../constants/Constant';
import CustomToast from './customToast';

function UserCurrentLocation() {
  const [currentLocation, setCurrentLocation] = useState({
    district: '',
    state: '',
    pincode: ''
  });

  const { addToast } = CustomToast();
  const [geoPermissionStatus, setGeoPermissionStatus] = useState(null); 

  // Reverse geocode lat/lng
  async function reverseGeocode(lat, lng) {
    const response = await fetch(
      `https://api.opencagedata.com/geocode/v1/json?q=${lat}+${lng}&key=${GEO_LOCATION_WEB_KEY}`
    );

    const data = await response.json();
    const components = data.results?.[0]?.components || {};
    return {
      district: components.city || components.town || components.county || '',
      state: components.state || '',
      pincode: components.postcode || ''
    };
  }

  // Get user location
  const navigatorFun = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          const address = await reverseGeocode(latitude, longitude);
          setCurrentLocation(address);

          const now = Date.now();
          sessionStorage.setItem(
            'userLocation',
            JSON.stringify({ data: address, timestamp: now })
          );
        },
        (error) => {
          console.error("Geolocation error:", error);
          addToast({ message: 'Unable to fetch location Please enable it in your browser settings to continue', status: 'error' });
        }
      );
    } else {
      console.warn("Geolocation not supported.");
    }
  };

  useEffect(() => {
    const stored = sessionStorage.getItem('userLocation');
    const now = Date.now();
    const twentyFourHours = 24 * 60 * 60 * 1000;

    if (stored) {
      try {
        const { data, timestamp } = JSON.parse(stored);
        if (now - timestamp < twentyFourHours) {
          setCurrentLocation(data);
          return;
        } else {
          sessionStorage.removeItem('userLocation');
        }
      } catch (e) {
        sessionStorage.removeItem('userLocation');
      }
    }

    if (navigator.permissions) {
      navigator.permissions.query({ name: 'geolocation' }).then((result) => {
        const permission = result.state;
        setGeoPermissionStatus(permission);
        sessionStorage.setItem('geo_permission', permission);

        // if (permission === 'granted' || permission === 'prompt') {
        //   navigatorFun();
        // } else if (permission === 'denied') {
        //   addToast({
        //     message: 'Location access denied. Please enable it in your browser settings to continue.',
        //     status: 'error'
        //   });
        // }
        if (geoPermissionStatus === 'denied') {
          addToast({
            message: 'Location access denied. Please enable it in your browser settings to continue.',
            status: 'error',
          });
        } else if (geoPermissionStatus === 'granted') {
          navigatorFun();
        }
        result.onchange = () => {
          const updated = result.state;
          setGeoPermissionStatus(updated);
          sessionStorage.setItem('geo_permission', updated);

          if (updated === 'granted') {
            addToast({ message: 'Location access granted!', status: 'success' });
            navigatorFun();
          } else if (updated === 'denied') {
            console.log("Location access denied again")
            // addToast({ message: 'Location access denied again.', status: 'error' });
          }
        };
      }).catch((err) => {
        console.error("Permission API error:", err);
        navigatorFun();
      });
    } else {
      navigatorFun();
    }
  }, []);

  return { navigatorFun, currentLocation, geoPermissionStatus };
}

export default UserCurrentLocation;
